import { render } from "./AddUpdatesModal.vue?vue&type=template&id=675481a3&scoped=true"
import script from "./AddUpdatesModal.vue?vue&type=script&lang=js"
export * from "./AddUpdatesModal.vue?vue&type=script&lang=js"

import "./AddUpdatesModal.vue?vue&type=style&index=0&id=675481a3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675481a3"]])

export default __exports__